import IconChevronDown from '@apollo/icons/default/IconChevronDown.svg';
import IconChevronUp from '@apollo/icons/default/IconChevronUp.svg';
import { IconButton } from '@apollo/orbit';
import * as monacoEditor from 'monaco-editor';
import React, { useEffect, useState } from 'react';

import { Tooltip } from 'src/components/common/tooltip/Tooltip';

export const DiffNavigatorButtons = ({
  diffEditor,
  diffNavigator,
  disabled,
}: {
  diffEditor: monacoEditor.editor.IStandaloneDiffEditor;
  diffNavigator: monacoEditor.editor.IDiffNavigator;
  disabled?: boolean;
}) => {
  const [numberOfChanges, setNumberOfChanges] = useState<number>();
  const [currentChange, setCurrentChange] = useState<number>(
    diffNavigator.nextIdx + 1,
  );

  useEffect(() => {
    const disposable = diffEditor.onDidUpdateDiff(() => {
      const lineChangesLength = diffEditor.getLineChanges()?.length;
      setNumberOfChanges(lineChangesLength);
      if (
        diffNavigator.nextIdx === -1 || // TODO(maya): figure out why this sometimes starts out at -1
        (lineChangesLength && diffNavigator.nextIdx + 1 > lineChangesLength) // when going from a diff with a large number of changes, to a diff with a smaller number - the currentChange isn't updated
      ) {
        diffNavigator.next();
        setCurrentChange(1);
      } else {
        setCurrentChange(diffNavigator.nextIdx + 1);
      }
    });
    return () => disposable.dispose();
  }, [diffEditor, diffNavigator]);

  if (!numberOfChanges || numberOfChanges < 1) return null;

  return (
    <div className="flex items-center">
      {!disabled && (
        <div className="mr-3 text-sm text-secondary">
          {currentChange} of {numberOfChanges} changes
        </div>
      )}
      <Tooltip label="Previous change" disabled={disabled}>
        <IconButton
          aria-label="Previous change"
          isDisabled={disabled}
          size="sm"
          className="mr-1"
          variant="secondary"
          onClick={() => {
            if (diffNavigator.canNavigate()) {
              diffNavigator.previous();
              setCurrentChange(diffNavigator.nextIdx + 1);
            }
          }}
        >
          <IconChevronUp />
        </IconButton>
      </Tooltip>
      <Tooltip label="Next change" disabled={disabled}>
        <IconButton
          aria-label="Next change"
          isDisabled={disabled}
          size="sm"
          className="mr-4"
          variant="secondary"
          onClick={() => {
            if (diffNavigator.canNavigate()) {
              diffNavigator.next();
              setCurrentChange(diffNavigator.nextIdx + 1);
            }
          }}
        >
          <IconChevronDown />
        </IconButton>
      </Tooltip>
    </div>
  );
};
